var AspectRatios;
(function (AspectRatios) {
    AspectRatios[AspectRatios["xxxWide"] = 3.5555555555555554] = "xxxWide";
    AspectRatios[AspectRatios["xxWide"] = 2.3333333333333335] = "xxWide";
    AspectRatios[AspectRatios["xWide"] = 1.7777777777777777] = "xWide";
    AspectRatios[AspectRatios["wide"] = 1.3333333333333333] = "wide";
    AspectRatios[AspectRatios["square"] = 1] = "square";
    AspectRatios[AspectRatios["tall"] = 0.8] = "tall";
    AspectRatios[AspectRatios["xTall"] = 0.5625] = "xTall";
})(AspectRatios || (AspectRatios = {}));
export const createCustomAspectRatio = (value) => value;
export default AspectRatios;
